import { render, staticRenderFns } from "./DrugList.vue?vue&type=template&id=c9274c5e&"
import script from "./DrugList.vue?vue&type=script&lang=js&"
export * from "./DrugList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports